import React from 'react';
import { componentName } from './const';
import WmsPrint from './wms-print';
import './index.scss';
function View(props) {
    const { jsonProps } = props;
    const targetProps = jsonProps
        ? {
            ...props,
            ...jsonProps,
        }
        : props;
    return React.createElement(WmsPrint, { ...targetProps });
}
View.displayName = componentName;
export default View;
